
export const ALL_ROLE_REQUEST = "ALL_ROLE_REQUEST";
export const ALL_ROLE_SUCCESS = "ALL_ROLE_SUCCESS";
export const ALL_ROLE_FAIL = "ALL_ROLE_FAIL";
export const ROLE_LIST_REQUEST = "ROLE_LIST_REQUEST";
export const ROLE_LIST_SUCCESS = "ROLE_LIST_REQUEST";
export const ROLE_LIST_FAIL = "ROLE_LIST_REQUEST";